import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { bodyB } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
`;
export const BtnWrapper = styled.div`
  display: flex;
  margin-top: auto;
  margin-left: auto;
  gap: 10px;
`;
export const Btn = css`
  height: 48px;
  padding: 16px 20px;

  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  ${bodyB};
`;
export const PrevBtn = styled.button`
  ${Btn};
  background-color: transparent;
  color: ${vars.neutral[80]};
`;
export const NextBtn = styled.button`
  :disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  ${Btn};
  background-color: ${vars.brand.default};
  color: white;
`;
